import React from 'react';
import { useTranslation } from 'react-i18next';
import rankingSubscriptionImg from '@/assets/images/ratings/ranking-subscription-state.webp';
import rankingSubscriptionMobileImg from '@/assets/images/ratings/ranking-subscription-mobile.webp';
import ratingsSubscriptionImg from '@/assets/images/ratings/subscription-state.webp';
import ratingsSubscriptionMobileImg from '@/assets/images/ratings/subscription-mobile.webp';
import { RatingsPaywallBanner } from '@/pages/Overview/RatingsPaywallBanner';

export const RatingsPaywall: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 flex-col pt-1 md:px-6 md:py-6">
      <div className="flex flex-col gap-4 rounded-t-2xl bg-popover pt-4 pb-8 md:gap-6 md:rounded-[20px] md:bg-card md:py-6">
        <div className="px-5">
          <h1 className="text-[16px]/[24px] font-medium text-foreground md:text-[24px]/[32px] md:font-semibold">
            {t('overview.tabs.ratings')}
          </h1>
        </div>

        <div className="flex flex-col gap-8 px-5 md:gap-10">
          <section className="flex flex-col gap-4 md:gap-6">
            <h2 className="text-subhead-14 text-muted-foreground md:text-callout-16 md:text-foreground">
              {t('overview.ratings.gradesTitle')}
            </h2>
            <RatingsPaywallBanner
              image={ratingsSubscriptionImg}
              mobileImage={ratingsSubscriptionMobileImg}
            />
          </section>

          <section className="flex flex-col gap-4 md:gap-6">
            <h2 className="text-subhead-14 text-muted-foreground md:text-callout-16 md:text-foreground">
              {t('overview.ratings.ranking.title')}
            </h2>
            <RatingsPaywallBanner
              image={rankingSubscriptionImg}
              mobileImage={rankingSubscriptionMobileImg}
            />
          </section>
        </div>
      </div>
    </div>
  );
};
